import { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Axios from "axios";
import crypto from "crypto-js";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../app/redux/hooks";
import {
  paymentVerificationAsync,
  setOrderDetails,
} from "../../../../../../app/slices/checkoutSlice/CheckoutSlice";
import { showSnackbar } from "../../../../../../app/slices/common/customSnackBar/customSnackbarSlice";
import { useNavigate } from "react-router-dom";

// Function to load script and append in DOM tree.
const loadScript = (src: any) =>
  new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });

const RenderRazorpay = ({
  orderId,
  razorpayorderId,
  keyId,
  keySecret,
  currency,
  amount,
}: any) => {
  const isModalOpened = useRef(false);
  const appUrl: string | undefined = process.env.REACT_APP_API_URL;
  const paymentId = useRef(null);
  const paymentMethod = useRef(null);
  const navigate = useNavigate();
  const rzpRef = useRef<any>(null);

  const dispatch = useAppDispatch();

  // To load razorpay checkout modal script.
  const displayRazorpay = async (options: any) => {
    if (isModalOpened.current) return; // Prevent multiple calls
    isModalOpened.current = true;
    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
      console.log("Razorpay SDK failed to load. Are you online?");
      return;
    }

    rzpRef.current = new (window as any).Razorpay(options);
    rzpRef.current.open();
  };

  const handlePayment = async (status: any, orderDetails = {}) => {
    dispatch(paymentVerificationAsync(orderDetails)).then((response: any) => {
      if (response?.payload && response?.payload?.status === 200) {
        dispatch(setOrderDetails(response?.payload?.data?.order_details));
        const orderDetails = response?.payload?.data?.order_details;
        localStorage.removeItem("order_uuid");
        localStorage.setItem("orderDetails", JSON.stringify(orderDetails));
        rzpRef.current.close();
        navigate("/order-confirmation");
        // setTimeout(() => {
        //   window.location.reload();
        // }, 2000);
      } else {
        dispatch(
          showSnackbar({
            message: "Please try again later.",
            severity: "error",
            autoHide: 3000,
          })
        );
        navigate("/");
        // setTimeout(() => {
        //   window.location.reload();
        // }, 2000);
      }
    });
  };

  // we will be filling this object in next step.
  const options = {
    key: keyId,
    amount,
    currency,
    name: "Navya Bakes",
    order_id: razorpayorderId,
    handler: (response: any) => {
      const succeeded =
        crypto
          .HmacSHA256(
            `${razorpayorderId}|${response.razorpay_payment_id}`,
            keySecret
          )
          .toString() === response.razorpay_signature;

      if (succeeded) {
        handlePayment("succeeded", {
          razorpay_order_id: razorpayorderId,
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_signature: response.razorpay_signature,
        });
      } else {
        handlePayment("failed", {
          razorpay_order_id: orderId,
          razorpay_payment_id: response?.razorpay_payment_id,
          razorpay_signature: response?.razorpay_signature,
        });
      }
    },
    modal: {
      confirm_close: false,
      ondismiss: async (reason: any) => {
        const {
          reason: paymentReason,
          field,
          step,
          code,
        }: any = reason && reason.error ? reason.error : {};
        // Reason 1 - when payment is cancelled. It can happend when we click cross icon or cancel any payment explicitly.
        if (reason === undefined) {
          navigate("/order-failed");

          // handlePayment("Cancelled");
        }
        // Reason 2 - When modal is auto closed because of time out
        else if (reason === "timeout") {
          navigate("/order-failed");
        }
        // Reason 3 - When payment gets failed.
        else {
          navigate("/order-failed");

          // handlePayment("failed", {
          //   paymentReason,
          //   field,
          //   step,
          //   code,
          // });
        }
      },
    },

    retry: {
      enabled: false,
    },
    timeout: 900,
    theme: {
      color: "",
    },
    redirect: false,
  };

  useEffect(() => {
    if (orderId && razorpayorderId && amount) {
      displayRazorpay(options);
    }
  }, [orderId, razorpayorderId, amount]);

  return null;
};

export default RenderRazorpay;
